import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useDirectionHandlerPresenter } from './DirectionHandler.presenter';

export const DirectionHandler: FC = observer(() => {
  useDirectionHandlerPresenter();

  return null;
});
